import * as React from 'react';

export const FacebookIcon: React.FC = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.4375 0H2.8125C2.06658 0 1.35121 0.296316 0.823762 0.823762C0.296316 1.35121 0 2.06658 0 2.8125L0 23.4375C0 24.1834 0.296316 24.8988 0.823762 25.4262C1.35121 25.9537 2.06658 26.25 2.8125 26.25H10.8545V17.3256H7.16309V13.125H10.8545V9.92344C10.8545 6.28184 13.0225 4.27031 16.343 4.27031C17.9332 4.27031 19.5961 4.55391 19.5961 4.55391V8.12813H17.7639C15.9586 8.12813 15.3955 9.24844 15.3955 10.3975V13.125H19.4256L18.7811 17.3256H15.3955V26.25H23.4375C24.1834 26.25 24.8988 25.9537 25.4262 25.4262C25.9537 24.8988 26.25 24.1834 26.25 23.4375V2.8125C26.25 2.06658 25.9537 1.35121 25.4262 0.823762C24.8988 0.296316 24.1834 0 23.4375 0Z"
        fill="black"
      />
    </svg>
  );
};
